import { useTheme } from "./provider/theme";

const StatsCard = ({ title, icons, value, iconBackgroundColor}: {
    title: string,
    icons: React.ReactNode,
    value: number | string,
    iconBackgroundColor?: string,
}) => {

    const {theme} = useTheme()

    return (
        <div className={`flex flex-col p-4 ${theme === 'dark' ? 'bg-gray-800 text-white' : 'bg-white'} rounded-lg shadow-md`}>
            <div className="flex items-center justify-between mb-2">
                <div className="space-x-2 mb-2">
                    <h3 className={`text-[20px] font-semibold ${theme === 'dark' ? 'bg-gray-800 text-gray-400' : 'bg-white'}`}>{title}</h3>
                    <p className="text-2xl !m-0 font-bold">{typeof value === 'number' ? value.toLocaleString() : value}</p>
                </div>
                <div className="flex items-center space-x-2 mr-4"
                    style={{ backgroundColor: iconBackgroundColor || '#2563eb', padding: '8px', borderRadius: '8px' }}
                >
                    {icons}
                </div>
            </div>

        </div>
    );
}

export default StatsCard;